export default __webpack_public_path__ + "static/media/sem-foto.cfea8412.png";